import { useEffect } from 'react';

const useOnLoad = (callback: () => void) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};

export default useOnLoad;
